(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/huxflux-radio.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/huxflux-radio.js');

'use strict';

const huxfluxRadio = Radio.channel(svs.numbergames.game.huxfluxRadio);
const currentlyHuxfluxing = new Map();
huxfluxRadio.reply('notifyOnAllHuxfluxEnd', notifyOnHuxfluxEnd => {
  if (!currentlyHuxfluxing.size) {
    notifyOnHuxfluxEnd === null || notifyOnHuxfluxEnd === void 0 || notifyOnHuxfluxEnd();
    return;
  }
  const onHuxfluxEnd = () => {
    if (!currentlyHuxfluxing.size) {
      notifyOnHuxfluxEnd === null || notifyOnHuxfluxEnd === void 0 || notifyOnHuxfluxEnd();
      huxfluxRadio.off('huxflux:end', onHuxfluxEnd);
    }
  };
  huxfluxRadio.on('huxflux:end', onHuxfluxEnd);
});
huxfluxRadio.on('huxflux:start', (board, numbersSize, numbersExtraSize) => {
  if (currentlyHuxfluxing.has(board)) {
    if (board.get('isActive')) {
      huxfluxRadio.trigger('huxflux:numbers', board, currentlyHuxfluxing.get(board));
    }
    return;
  }
  const numbers = board.get('numbers');
  const numbersExtra = board.get('numbersExtra');
  const numbersToHuxflux = [];
  currentlyHuxfluxing.set(board, numbersToHuxflux);
  const randomNumbers = numbers.prepareHuxflux(numbersSize);
  numbersToHuxflux.push(...randomNumbers.map(number => ({
    number
  })));
  if (numbersExtra) {
    const randomNumbers = numbersExtra.prepareHuxflux(numbersExtraSize);
    numbersToHuxflux.push(...randomNumbers.map(number => ({
      number,
      isExtra: true
    })));
  }
  setTimeout(() => {
    if (board.get('isActive')) {
      huxfluxRadio.trigger('huxflux:numbers', board, numbersToHuxflux);
    }
    huxfluxNumber(board, numbersToHuxflux);
  }, 300);
});
huxfluxRadio.on('huxflux:end', board => {
  board.numberlistsChanged();
});
function huxfluxNumber(board, _ref) {
  let [number, ...numbers] = _ref;
  if (number) {
    board.addHuxfluxed(number);
    if (numbers.length) {
      setTimeout(() => {
        huxfluxNumber(board, numbers);
      }, 200);
    } else {
      setTimeout(() => {
        currentlyHuxfluxing.delete(board);
        huxfluxRadio.trigger('huxflux:end', board);
      }, 800);
    }
  }
}

 })(window);